import { defineStore } from "pinia";
import { Layout, Key } from "@/keyboard/layout";

const KEY_SIZE = { x: 18, y: 18 };
const GHANIMA_LAYOUT = new Layout([
  [
    new Key(0.0, 57.15, 0.0, KEY_SIZE),
    new Key(19.05, 59.53, 0.0, KEY_SIZE),
    new Key(38.1, 69.06, 0.0, KEY_SIZE),
    new Key(57.15, 73.82, 0.0, KEY_SIZE),
    new Key(76.2, 69.06, 0.0, KEY_SIZE),
    new Key(95.25, 65.72, 0.0, KEY_SIZE),
    new Key(193.25, 65.72, 0.0, KEY_SIZE),
    new Key(212.3, 69.06, 0.0, KEY_SIZE),
    new Key(231.35, 73.82, 0.0, KEY_SIZE),
    new Key(250.4, 69.06, 0.0, KEY_SIZE),
    new Key(269.45, 59.53, 0.0, KEY_SIZE),
    new Key(288.5, 57.15, 0.0, KEY_SIZE),
  ],
  [
    new Key(0.0, 38.1, 0.0, KEY_SIZE),
    new Key(19.05, 40.48, 0.0, KEY_SIZE),
    new Key(38.1, 50.01, 0.0, KEY_SIZE),
    new Key(57.15, 54.77, 0.0, KEY_SIZE),
    new Key(76.2, 50.01, 0.0, KEY_SIZE),
    new Key(95.25, 46.67, 0.0, KEY_SIZE),
    new Key(193.25, 46.67, 0.0, KEY_SIZE),
    new Key(212.3, 50.01, 0.0, KEY_SIZE),
    new Key(231.35, 54.77, 0.0, KEY_SIZE),
    new Key(250.4, 50.01, 0.0, KEY_SIZE),
    new Key(269.45, 40.48, 0.0, KEY_SIZE),
    new Key(288.5, 38.1, 0.0, KEY_SIZE),
  ],
  [
    new Key(0.0, 19.05, 0.0, KEY_SIZE),
    new Key(19.05, 21.43, 0.0, KEY_SIZE),
    new Key(38.1, 30.96, 0.0, KEY_SIZE),
    new Key(57.15, 35.72, 0.0, KEY_SIZE),
    new Key(76.2, 30.96, 0.0, KEY_SIZE),
    new Key(95.25, 27.62, 0.0, KEY_SIZE),
    new Key(193.25, 27.62, 0.0, KEY_SIZE),
    new Key(212.3, 30.96, 0.0, KEY_SIZE),
    new Key(231.35, 35.72, 0.0, KEY_SIZE),
    new Key(250.4, 30.96, 0.0, KEY_SIZE),
    new Key(269.45, 21.43, 0.0, KEY_SIZE),
    new Key(288.5, 19.05, 0.0, KEY_SIZE),
  ],
  [
    new Key(0.0, 0.0, 0.0, KEY_SIZE),
    new Key(19.05, 2.38, 0.0, KEY_SIZE),
    new Key(38.1, 11.91, 0.0, KEY_SIZE),
    new Key(57.15, 16.67, 0.0, KEY_SIZE),
    new Key(76.2, 11.91, 0.0, KEY_SIZE),
    new Key(95.25, 8.57, 0.0, KEY_SIZE),
    new Key(193.25, 8.57, 0.0, KEY_SIZE),
    new Key(212.3, 11.91, 0.0, KEY_SIZE),
    new Key(231.35, 16.67, 0.0, KEY_SIZE),
    new Key(250.4, 11.91, 0.0, KEY_SIZE),
    new Key(269.45, 2.38, 0.0, KEY_SIZE),
    new Key(288.5, 0.0, 0.0, KEY_SIZE),
  ],
  [
    new Key(68.07, -10.1, 3.0, KEY_SIZE),
    new Key(88.95, -11.94, -13.06, KEY_SIZE),
    new Key(108.5, -19.48, -29.12, KEY_SIZE),
    new Key(125.2, -32.14, -45.18, KEY_SIZE),
    null,
    null,
    null,
    null,
    new Key(163.3, -32.14, 45.18, KEY_SIZE),
    new Key(180.0, -19.48, 29.12, KEY_SIZE),
    new Key(199.56, -11.94, 13.06, KEY_SIZE),
    new Key(220.43, -10.1, -3.0, KEY_SIZE),
  ],
]);

export const useLayoutStore = defineStore("layout", {
  state: () => {
    return {
      name: "ghanima",
      layout: GHANIMA_LAYOUT,
    };
  },

  getters: {
    allCount(state): number {
      return state.layout.iter().length;
    },

    rowCounts(state): Record<number, number> {
      return state.layout.iter().reduce((counts, key) => {
        counts[key.row] = (counts[key.row] ?? 0) + 1;
        return counts;
      }, {} as Record<number, number>);
    },

    columnCounts(state): Record<number, number> {
      return state.layout.iter().reduce((counts, key) => {
        counts[key.col] = (counts[key.col] ?? 0) + 1;
        return counts;
      }, {} as Record<number, number>);
    },
  },
});
